import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ProjectGallery({ images = [], alt = "", testid }) {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start" });
  const [idx, setIdx] = useState(0);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);

  useEffect(() => {
    if (!embla) return;
    const onSelect = () => setIdx(embla.selectedScrollSnap());
    embla.on("select", onSelect);
    onSelect();
    return () => embla.off("select", onSelect);
  }, [embla]);

  const list = images.length > 0 ? images : [null];

  return (
    <div className="relative group" data-testid={testid}>
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {list.map((src, i) => (
            <div key={src || `blank-${i}`} className="min-w-full">
              {src ? (
                <img src={src} alt={alt} className="w-full max-h-[220px] object-cover" />
              ) : (
                <div className="w-full h-[220px] bg-muted" />
              )}
            </div>
          ))}
        </div>
      </div>
      {list.length > 1 && (
        <>
          <button type="button" onClick={scrollPrev} aria-label="Previous"
            className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-background/80 backdrop-blur border border-border flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            data-testid={`${testid}-prev`}>
            <ChevronLeft size={16} />
          </button>
          <button type="button" onClick={scrollNext} aria-label="Next"
            className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-background/80 backdrop-blur border border-border flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            data-testid={`${testid}-next`}>
            <ChevronRight size={16} />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {list.map((src, i) => (
              <span key={src || `dot-${i}`} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ${i === idx ? "w-4 bg-primary" : "w-1.5 bg-background/70"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
